import { render, staticRenderFns } from "./IsEbike.vue?vue&type=template&id=201c8aae&scoped=true"
import script from "./IsEbike.vue?vue&type=script&lang=js"
export * from "./IsEbike.vue?vue&type=script&lang=js"
import style0 from "./IsEbike.vue?vue&type=style&index=0&id=201c8aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c8aae",
  null
  
)

export default component.exports